import React, { Component } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { toastr } from 'react-redux-toastr';
import { submit } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { renderToString } from 'react-dom/server';

import { parseStyle } from '../../../utils/helpers/style_parser';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';
import TemplatesForm from './TemplatesForm';

class TemplatesModal extends Component {
  onFormSubmit(values) {
    const { dispatch, template, handleHide, templates, formAction, website } = this.props;
    const label = values.template.label;

    const reactSnippet = () => {
      const styles = parseStyle(label.styles);

      return (
        <div style={{ ...styles, display: 'block' }}>
          <a style={{ color: styles.color, margin: 0, padding: 0 }} rel="noopener noreferrer" href='https://www.jobadx.com' target='_blank'>
            Sponsored by JobAdx
          </a>
        </div>
      );
    };

    label.snippet = renderToString(reactSnippet());

    const templateData = {
      ...values.template,
      custom_label: values.template.custom_label === 'true',
      label: {
        styles: {
          textAlign: get(values, 'template.label.styles.textAlign', 'left'),
          fontSize: parseInt(get(values, 'template.label.styles.fontSize', 18), 10),
          color: {
            r: parseInt(get(values, 'template.label.styles.color.r', 0), 10),
            g: parseInt(get(values, 'template.label.styles.color.g', 0), 10),
            b: parseInt(get(values, 'template.label.styles.color.b', 0), 10),
            a: parseFloat(get(values, 'template.label.styles.color.a', 1.0))
          },
			    backgroundColor: {
            r: parseInt(get(values, 'template.label.styles.backgroundColor.r', 255), 10),
            g: parseInt(get(values, 'template.label.styles.backgroundColor.g', 255), 10),
            b: parseInt(get(values, 'template.label.styles.backgroundColor.b', 255), 10),
            a: parseFloat(get(values, 'template.label.styles.backgroundColor.a', 1.0))
          },
          margin: {
            top: parseInt(get(values, 'template.label.styles.margin.top', 0), 10),
            right: parseInt(get(values, 'template.label.styles.margin.right', 0), 10),
            bottom: parseInt(get(values, 'template.label.styles.margin.bottom', 0), 10),
            left: parseInt(get(values, 'template.label.styles.margin.left', 0), 10)
          },
          padding: {
            top: parseInt(get(values, 'template.label.styles.padding.top', 0), 10),
            right: parseInt(get(values, 'template.label.styles.padding.right', 0), 10),
            bottom: parseInt(get(values, 'template.label.styles.padding.bottom', 0), 10),
            left: parseInt(get(values, 'template.label.styles.padding.left', 0), 10)
          }
        },
        snippet: get(values, 'template.label.snippet', ''),
      },
      snippet: get(values, 'template.snippet', ''),
    };

    const args = formAction === 'Update' ?
      [template.uuid, { template: templateData }] : [{ publisher_website_id: website.uuid, template: templateData }];

    dispatch(setLoader('TemplateForm'));
    dispatch(PublisherApi.actions[`template${formAction}`].post(...args, (_error, success) => {
      dispatch(removeLoader('TemplateForm'));
      if (success) {
        let collection = [...templates.data];

        if (formAction === 'Update') {
          collection = [...templates.data].map((obj) => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });
        } else if (formAction === 'Create') {
          collection.unshift(success.data);
        }

        dispatch({
          type: PublisherApi.events.templates.actionSuccess,
          syncing: false,
          data: {
            ...templates, data: collection, meta: { ...templates.meta }, template: success.data
          }
        });

        handleHide();
      }
    }));
  }

  handleHide() {
    const { dirty, handleHide } = this.props;
    if (!dirty) {
      handleHide();
    } else {
      toastr.error('You have unsaved changes to your template.  Please save before exiting or press Cancel to close without saving');
    }
  }

  render() {
    const { show, heading, isLoading, handleHide, dispatch, template, website } = this.props;
    return (
      <Modal
        bsSize='large'
        show={show}
        onHide={this.handleHide.bind(this)}
      >
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className='alert alert-warning' style={{ padding: '20px' }}>
            <span>
              The ability to edit the Custom sections of this form has been disabled, 
              please use the builder options instead (in the General and Label tabs). 
              If you need a custom template, or want to make changes to your existing custom template 
              please contact us directly and we can the change.
            </span>
          </div>
          <Row>
            <Col md={12}>
              <TemplatesForm
                handleTemplateSubmit={this.onFormSubmit.bind(this)}
                website={website}
                template={template}
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button
            onClick={handleHide}
          >
            Cancel
          </Button>
          <Button
            type='submit'
            bsStyle='success'
            onClick={() => dispatch(submit('TemplateForm'))}
            loading={isLoading}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const ResourceModal = connectModal({
  name: 'TemplateFormModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { TemplateFormModal } } = state;
  const isLoading = loader.includes('TemplateForm');
  const template = get(TemplateFormModal, 'props.template', {});
  const templates = get(state, 'publisher.templates.data', {});
  const website = get(TemplateFormModal, 'props.website', {});
  
  return { isLoading, templates, template, website };
};

export default connect(mapStateToProps)(ResourceModal(TemplatesModal));
